export default {
    SET_IS_APP_LOADING(state, isAppLoading) {
        state.isAppLoading = isAppLoading;
    },

    SET_IS_APP_INITIALIZED(state, isAppInitialized) {
        state.isAppInitialized = isAppInitialized;
    },

    SET_IS_APP_INITIALIZING(state, isAppInitializing) {
        state.isAppInitializing = isAppInitializing;
    },

    SET_AUTH_USER_APP_RESOURCE(state, resource) {
        state.authUserAppResource = resource;
    },
};
